export const DEFAULT_ACTION_TIMEOUT_PROMPT = 'Do you still want to participate?'

// Default labels for the timeout prompt.
export const DEFAULT_ACTION_TIMEOUT_RESET_LABEL = 'Yes'
export const DEFAULT_ACTION_TIMEOUT_EXIT_LABEL = 'No'

/** Stock exit button behavior: leave the event. */
export const EXIT_ACTION_EXIT = 'exit'

/** Exit button publishes ACTION_TIMEOUT (in-game forfeit) instead of leaving. */
export const EXIT_ACTION_TIMEOUT = 'timeout'

/** reset-action default: re-arm phase 1 (legacy I'm still here behavior). */
export const RESET_ACTION_REARM = 'rearm'

/** reset-action dismiss: close modal, re-enable controls, keep modal penalty timer. */
export const RESET_ACTION_DISMISS = 'dismiss'

// If a duration only provides one value, use this as the modal timeout.
export const DEFAULT_ACTION_TIMEOUT_MODAL_MS = 15000

export function parseDurationAttribute(durationAttr) {
  if (durationAttr == null) return null
  if (typeof durationAttr !== 'string') return null

  const raw = durationAttr.trim()
  if (!raw) return null

  const parts = raw.split(',').map(p => p.trim()).filter(Boolean)
  if (parts.length < 1 || parts.length > 2) return null

  const actionMs = Number.parseInt(parts[0], 10)
  if (!Number.isFinite(actionMs) || actionMs <= 0) return null

  let modalMs = DEFAULT_ACTION_TIMEOUT_MODAL_MS
  if (parts.length === 2) {
    const parsedModal = Number.parseInt(parts[1], 10)
    if (!Number.isFinite(parsedModal) || parsedModal <= 0) return null
    modalMs = parsedModal
  }

  return { actionMs, modalMs }
}

export function parsePromptAttribute(promptAttr) {
  if (promptAttr == null) return DEFAULT_ACTION_TIMEOUT_PROMPT
  const s = String(promptAttr).trim()
  return s ? s : DEFAULT_ACTION_TIMEOUT_PROMPT
}

/** True if the element has a non-empty prompt (show modal). Missing or empty => no prompt (send ACTION_TIMEOUT only). */
export function hasPromptAttribute(el) {
  if (!el || !el.hasAttribute('prompt')) return false
  const s = String(el.getAttribute('prompt') || '').trim()
  return s.length > 0
}

// reset="YES" (label). If omitted/blank, uses default.
export function parseResetAttribute(resetAttr) {
  if (resetAttr == null) return DEFAULT_ACTION_TIMEOUT_RESET_LABEL
  const s = String(resetAttr).trim()
  return s ? s : DEFAULT_ACTION_TIMEOUT_RESET_LABEL
}

// exit="NO" (label). If omitted/blank, returns null => no exit button.
export function parseExitAttribute(exitAttr) {
  if (exitAttr == null) return null
  const s = String(exitAttr).trim()
  return s ? s : null
}

// exit-action="timeout" => exit button publishes ACTION_TIMEOUT; otherwise leave event.
export function parseExitActionAttribute(exitActionAttr) {
  if (exitActionAttr == null) return EXIT_ACTION_EXIT
  const normalized = String(exitActionAttr).trim().toLowerCase()
  return normalized === EXIT_ACTION_TIMEOUT ? EXIT_ACTION_TIMEOUT : EXIT_ACTION_EXIT
}

export function shouldExitPublishActionTimeout(timeoutEl) {
  if (!timeoutEl || typeof timeoutEl.getAttribute !== 'function') return false
  return parseExitActionAttribute(timeoutEl.getAttribute('exit-action')) === EXIT_ACTION_TIMEOUT
}

export function parseResetActionAttribute(resetActionAttr) {
  if (resetActionAttr == null) return RESET_ACTION_REARM
  const normalized = String(resetActionAttr).trim().toLowerCase()
  return normalized === RESET_ACTION_DISMISS ? RESET_ACTION_DISMISS : RESET_ACTION_REARM
}

export function shouldDismissPromptOnReset(timeoutEl) {
  if (!timeoutEl || typeof timeoutEl.getAttribute !== 'function') return false
  return parseResetActionAttribute(timeoutEl.getAttribute('reset-action')) === RESET_ACTION_DISMISS
}

export function publishModalActionTimeout({
  timeoutEl,
  publishAction,
  renderId = null,
  modalMs = null,
  timeoutId = null,
}) {
  if (!timeoutEl || typeof publishAction !== 'function') return false
  if (timeoutEl.getAttribute('data-anear-timeout-published') === 'modal_timeout') return false

  const payload = {
    ACTION_TIMEOUT: {
      stage: 'modal_timeout',
      renderId,
      modalMs: modalMs ?? null,
      timeoutId: timeoutId ?? null,
    },
  }
  timeoutEl.setAttribute('data-anear-timeout-published', 'modal_timeout')
  publishAction(JSON.stringify(payload))
  return true
}

